import { render } from "./Reference.vue?vue&type=template&id=ca4eba1c&scoped=true"
import script from "./Reference.vue?vue&type=script&lang=js"
export * from "./Reference.vue?vue&type=script&lang=js"

import "./Reference.vue?vue&type=style&index=0&id=ca4eba1c&lang=scss"
import "./Reference.vue?vue&type=style&index=1&id=ca4eba1c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca4eba1c"]])

export default __exports__